import { Header } from "./Header";
import { Row } from "./Row";

export class Table {
  constructor(
    public headers: Header[],
    public rows: Row[],
  ) {
  }

  public clearSelection(): void {
    for (const row of this.rows) {
      row.updateSelectStatusOfCells(false);
    }
  }

  public get isSelected(): boolean {
    for (const row of this.rows) {
      if (row.isSelected) { return true; }
    }
    return false;
  }

  public get selectedRows(): Row[] {
    const rows: Row[] = [];
    for (const row of this.rows) {
      if (!row.cells[0].isSelected) { continue; }
      rows.push(row);
    }
    return rows;
  }

  public clone(): Table {
    const headers: Header[] = [];
    const rows: Row[] = [];
    for (const header of this.headers) {
      headers.push(header.clone());
    }
    for (const row of this.rows) {
      rows.push(row.clone());
    }
    return new Table(headers, rows);
  }

  /**
   * IEでのメモリリーク対策
   */
  public destroy(): void {
    const rows = this.rows;
    this.rows = [];
    this.headers = [];
    for (const row of rows) {
      row.destroy();
    }
  }
}
